import script from "./PhieuXuatKhoPrintModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhieuXuatKhoPrintModal.vue?vue&type=script&setup=true&lang=ts"

import "./PhieuXuatKhoPrintModal.vue?vue&type=style&index=0&id=7d3d92ae&lang=scss"

const __exports__ = script;

export default __exports__